import { render, staticRenderFns } from "./PauseCode.vue?vue&type=template&id=2c6cbfae"
import script from "./PauseCode.vue?vue&type=script&lang=js"
export * from "./PauseCode.vue?vue&type=script&lang=js"
import style0 from "./PauseCode.vue?vue&type=style&index=0&id=2c6cbfae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports